/**
 * Pulse demo content — the sample schedules, triggers, skills, and updates.
 *
 * On by default in every build. `VITE_PULSE_DEMO=false` is a kill switch so a
 * deploy can turn the samples off without a revert.
 */
export function isPulseDemoEnabled() {
  return import.meta.env.VITE_PULSE_DEMO !== 'false'
}
